import request from '@/router/axios';

export const update = (row) => {
    return request({
        url: '/api/blade-sorder/orderinitialplan/submit',
        method: 'post',
        data: row
    })
}

export const add = (row) => {
    return request({
        url: '/api/blade-sorder/orderinitialplan/submit',
        method: 'post',
        data: row
    })
}

export const remove = (id) => {
    return request({
        url: '/api/blade-sorder/orderinitialplan/remove/'+id,
        method: 'post',
    })
}


export const getOrderInitPlanList = (orderInitialPlanId) => {
    return request({
        url: '/api/blade-sorder/orderinitialplan/specificList/'+orderInitialPlanId,
        method: 'get',
    })
}

export const addOrderInitPlan = (row) => {
    return request({
        url: '/api/blade-sorder/orderinitialplan/addSpecific',
        method: 'post',
        data: row
    })
}

export const updateOrderInitPlan = (row) => {
    return request({
        url: '/api/blade-sorder/orderinitialplan/addSpecific',
        method: 'post',
        data: row
    })
}

export const removeOrderInitPlan = (id) => {
    return request({
        url: '/api/blade-sorder/orderinitialplan/delSpecific/'+id,
        method: 'get',
    })
}
export const submitAuditHandle = (orderInitialPlanId) => {
    return request({
        url: '/api/blade-sorder/orderinitialplan/submitAudit2',
        method: 'post',
        data: {
            orderInitialPlanId:orderInitialPlanId
        }
    })
}

export const submitAudit2Handle = (orderInitialPlanId) => {
    return request({
        url: '/api/blade-sorder/orderinitialplan/submitAudit',
        method: 'post',
        data: {
            orderInitialPlanId:orderInitialPlanId
        }
    })
}


export const auditOneHandle = (data) => {
    return request({
        url: '/api/blade-sorder/orderinitialplan/audit2',
        method: 'post',
        data: data
    })
}

export const auditTwoHandle = (data) => {
    return request({
        url: '/api/blade-sorder/orderinitialplan/audit',
        method: 'post',
        data: data
    })
}



// 待确认,计划单列表 分页
export const toBeConfirmedList = (current, size) => {
    return request({
        url: '/api/blade-sorder/orderinitialplan/toBeConfirmedList',
        method: 'get',
        params: {
            current,
            size
        }
    })
}

// 进行中,计划单列表 分页
export const ongoingList = (current, size) => {
    return request({
        url: '/api/blade-sorder/orderinitialplan/ongoing',
        method: 'get',
        params: {
            current,
            size
        }
    })
}

// 已完成,计划单列表 分页
export const completeList = (current, size) => {
    return request({
        url: '/api/blade-sorder/orderinitialplan/complete',
        method: 'get',
        params: {
            current,
            size
        }
    })
}

// 待审核 计划列表 分页
export const toAuditList = (current, size) => {
    return request({
        url: '/api/blade-sorder/orderinitialplan/toAuditList',
        method: 'get',
        params: {
            current,
            size
        }
    })
}

// 确认计划 操作
export const confirmedHandle = (orderInitialPlanId) => {
    return request({
        url: '/api/blade-sorder/orderinitialplan/confirmed',
        method: 'post',
        data:{
            orderInitialPlanId:orderInitialPlanId
        }
    })
}

